<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>账号设置</span>
      </div>
      <el-form :model="form" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="form.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.newPassword" type="password" placeholder="留空则不修改"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.confirmPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "AccountSettings",
  data() {
    return { form: { username: "", nickname: "", phone: "", newPassword: "", confirmPassword: "" } };
  },
  mounted() { this.fetchProfile(); },
  methods: {
    fetchProfile() {
      vpost("/admin/currentUserinfo").then(res => {
        if (res.code === 200) {
          this.form.username = res.data?.username || "";
          this.form.nickname = res.data?.nickname || "";
          this.form.phone = res.data?.phone || "";
        }
      });
    },
    save() {
      if (this.form.newPassword && this.form.newPassword !== this.form.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      let dto = { nickname: this.form.nickname };
      if (this.form.newPassword) dto.newPassword = this.form.newPassword;
      vpost("/admin/updateProfile", dto).then(res => {
        if (res.code === 200) this.$message.success("保存成功");
        else this.$message.error(res.msg || "保存失败");
      });
    }
  }
};
</script>
